function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.78858,6.25647l.70711.70711L32.37437,9.0849l-.70711-.70711Zm-27.57716,0L8.33274,8.37779l-.70711.70711L5.50431,6.96358ZM40,20.25216v1H37v-1Zm-37,0v1H0v-1Zm17-10.981L16.62585,16.108,9.081,17.20416l5.45951,5.3219L13.251,30.04016,20,26.4926l6.748,3.54756-1.28851-7.5141,5.45851-5.3219L23.37415,16.108Zm0-4.519L24.70228,14.28,35.2169,15.80789,27.60845,23.2243l1.79611,10.47213L20,28.75216l-9.40456,4.94427L12.39155,23.2243,4.7831,15.80789,15.29772,14.28ZM7.62563,32.41942l.70711.7071L6.21142,35.24784l-.70711-.7071Zm24.74874,0,2.12132,2.12132-.70711.7071-2.12132-2.12132Z"
});

var SvgFavoritLarge = function SvgFavoritLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "40px",
    width: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFavoritLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/favorit-large.b8a17b1c.svg";
export { ForwardRef as ReactComponent };